import { useTranslations } from '@vocab/react';
import { Text } from 'braid-design-system';
import { useMemo } from 'react';

import type { ErrorType } from '../../types';

import translations from './.vocab';

interface ErrorMessageProps {
  errorType: ErrorType;
}

export const ErrorMessage = ({ errorType }: ErrorMessageProps) => {
  const { t } = useTranslations(translations);

  const errorText = useMemo(() => {
    switch (errorType) {
      case 'INPUT_OR_OUTPUT_BLOCKED':
        return t('I can only help you with your job search.');
      case 'TOO_MANY_REQUESTS':
        return t('You’ve done this too many times today. Try again later.');
      default:
        return t('Can we try that again? We’re having trouble connecting.');
    }
  }, [errorType, t]);

  return <Text tone="critical">{errorText}</Text>;
};
